<template>
  <div class="page-content animate__animated animate__fadeIn">
    <div class="border-bottom" style="margin-top:0;">
      <!-- 顶部搜索框 -->
      <div>
        <el-form :inline="true" :model="queryParams" class="demo-form-inline">
          <el-form-item label="角色名称">
            <el-input v-model="queryParams.roleName" placeholder="请输入角色名称进行查询" class="form-item-width"
              clearable></el-input>
          </el-form-item>
          <!-- <el-form-item class="right-btns">
            <el-button type="primary" @click="onSearch">查询</el-button>
            <el-button type="warning" @click="onReset">重置</el-button>
            <el-button type="primary" @click="handleroleAdd">新增</el-button>
          </el-form-item>-->
          <div class="btn-boxs">
            <div>
              <el-button icon="el-icon-plus" type="primary" @click="handleroleAdd">新 增</el-button>
              <el-button :disabled="!multipleSelection.length" icon="el-icon-delete" type="danger"
                @click="batchDelete">批量删除</el-button>
            </div>
            <div>
              <el-button icon="el-icon-search" type="primary" @click="onSearch">查 询</el-button>
              <el-button icon="el-icon-refresh" @click="onReset">重 置</el-button>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <div class="margin-top" style="margin-bottom:0;margin-top:15px">
      <!-- 表格组件 -->
      <el-table :data="tableData" v-loading="tableLoading" border row-key="deptId" default-expand-all
        :tree-props="{ children: 'children' }" highlight-current-row max-height="447"
        :header-cell-style="{ background: '#fafafa', color: '#606266', fontSize: '14px' }"
        @selection-change="handleSelectionChange">
        <!-- 多选 -->
        <el-table-column type="selection" width="55"></el-table-column>
        <!-- 序号列 -->
        <el-table-column align="center" type="index" label="序号" width="50"></el-table-column>
        <!-- 动态生成其他列 -->
        <el-table-column align="center" v-for="tab in tableTitle" :key="tab.code" :label="tab.name"
          show-overflow-tooltip :width="tab.width">
          <template slot-scope="scope">
            <!-- 针对 status 列的特殊处理 -->
            <span v-if="tab.code === 'status'"
              :style="scope.row.status === '0' ? { color: 'green' } : { color: 'red' }">{{ scope.row.status === '0' ?
          '正常' : '停用' }}</span>
            <span v-else-if="tab.code === 'dataScope'">{{ dataScopeMapping[scope.row.dataScope] }}</span>
            <!-- 其他列的常规展示 -->
            <span v-else>{{ scope.row[tab.code] }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="text" @click="updateData(scope.row)" class="update-btn">修改</el-button>
            <el-button style="color:red" type="text" @click="deleteData(scope.row)" class="update-btn">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <div>
        <Pagination background :total="pageParams.total" :page="pageParams.pageNum" :limit="pageParams.pageSize"
          @pagination="onChangePages" />
      </div>
    </div>
    <!-- 添加 修改角色 -->
    <el-dialog :title="dialogTitle" :visible.sync="deptFormVisible" width="30%" @close="handleDialogClose">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="角色名称" prop="roleName">
          <el-input v-model="form.roleName" autocomplete="off" placeholder="请输入角色名称"></el-input>
        </el-form-item>
        <el-form-item label="角色标识" prop="roleKey">
          <el-input v-model="form.roleKey" autocomplete="off" placeholder="请输入角色标识"></el-input>
        </el-form-item>
        <el-form-item label="数据范围" prop="dataScope">
          <el-select v-model="form.dataScope" placeholder="请选择数据范围">
            <el-option label="全部数据权限" value="0"></el-option>
            <el-option label="本部门数据权限" value="1"></el-option>
            <el-option label="本部门及以下数据权限" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="显示顺序" prop="roleSort">
          <el-input v-model="form.roleSort" autocomplete="off" placeholder="请输入显示顺序"></el-input>
        </el-form-item>
        <el-form-item label="角色状态" prop="status">
          <el-select v-model="form.status" placeholder="请选择角色状态">
            <el-option label="正常" value="0"></el-option>
            <el-option label="停用" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="菜单权限" prop="menuIds">
          <el-tree ref="subRoleTree" class="filter-tree" :data="menuTreeData" node-key="menuId" highlight-current
            show-checkbox @check="handleCheckChange" :default-checked-keys="selectedMenuIds"
            :expand-on-click-node="false"></el-tree>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" autocomplete="off" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :icon="dialogTitle === '新增' ? 'el-icon-plus' : 'el-icon-edit'" type="primary"
          @click="submitForm('form')">{{ dialogTitle === '新增' ? '立即添加' : '立即修改' }}</el-button>
        <el-button icon="el-icon-refresh" @click="resetForm('form')">重 置</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { getRoleList, roleAdd, roleById, updeteRole, deleteRole } from "@/api/admin-service/role";
import { getMenuTree } from "@/api/admin-service/menu.js";
export default {
  components: {
    Pagination
  },
  data() {
    return {
      tableLoading: false,
      form: {
        roleName: "", //角色名称
        roleKey: "", //负责人
        dataScope: "", //显示顺序
        roleSort: "", //联系电话
        status: "", //角色状态
        menuIds: [], //菜单权限
        remark: "" //备注
        // delFlag: "0" // ?
      },
      rules: {
        roleName: [
          { required: true, message: "请填写角色名称", trigger: "blur" }
        ],
        roleKey: [
          { required: true, message: "请填写角色标识", trigger: "blur" }
        ],
        dataScope: [
          { required: true, message: "请选择数据范围", trigger: "change" }
        ],
        roleSort: [
          {
            required: true,
            message: "请填写显示顺序",
            trigger: "blur"
          },
          {
            validator: (rule, value, callback) => {
              // 校验是否为正整数且大于 0
              if (!value) {
                callback(new Error("请填写显示顺序"));
              } else if (!/^[1-9]\d*$/.test(value)) {
                callback(new Error("显示顺序必须是大于 0 的正整数"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        status: [
          { required: true, message: "请选择角色状态", trigger: "change" }
        ],
        menuIds: [
          { required: true, message: "请选择菜单权限", trigger: "blur" }
        ],
        remark: [{ required: true, message: "请填写备注", trigger: "blur" }]
      },
      dialogTitle: "",
      updateId: "", //修改数据需要的id
      deptFormVisible: false,
      // 表格数据
      tableData: [],
      // 表格标题数组
      tableTitle: [
        { name: "角色名称", code: "roleName", width: "" },
        { name: "角色标识", code: "roleKey", width: "" },
        { name: "数据范围", code: "dataScope", width: "" },
        { name: "显示顺序", code: "roleSort", width: "" },
        { name: "角色状态", code: "status", width: "" },
        { name: "备注", code: "remark", width: "" }
      ],

      pageParams: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      queryParams: {
        orderByColumn: "",
        isAsc: "",
        roleName: "",
        orderBy: ""
      },
      dataScopeMapping: {
        "0": "全部数据权限",
        "1": "本部门数据权限",
        "2": "本部门及以下数据权限"
      },
      menuTreeData: [],
      selectedMenuIds: [], // 存储选中的节点的 menuIds
      multipleSelection: []
    };
  },
  mounted() {
    this.onGetDataList();
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    batchDelete() {
      this.$confirm(`提示，确定要删除选中的这些数据吗？`, {
        title: "提示",
        showCancelButton: true,
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        type: "warning",
        // 为按钮添加图标并设置为 mini 尺寸
        confirmButtonClass: "el-icon-check el-button--mini", // 确定按钮的图标和尺寸
        cancelButtonClass: "el-icon-close el-button--mini" // 取消按钮的图标和尺寸
      })
        .then(() => {
          // 使用 map() 来获取 roleId 组成的数组
          const ids = (this.multipleSelection || []).map(item => item.roleId);
          deleteRole({ ids }).then(res => {
            if (res?.data) {
              this.$message.success(res.msg || "删除成功");
              this.onGetDataList();
            }
          });
        })
        .catch(error => {
          console.log(error);
          // 取消删除时显示提示
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    queryMenuTree() {
      getMenuTree({
        menuName: ""
      }).then(res => {
        this.menuTreeData = res.data || [];
      });
    },

    //获取所有选中的节点id
    handleCheckChange() {
      //获取所有选中的节点id
      this.form.menuIds = this.$refs.subRoleTree
        .getCheckedKeys()
        .concat(this.$refs.subRoleTree.getHalfCheckedKeys());
    },
    // 增 / 改
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.dialogTitle === "新增") {
            const formData = { ...this.form };
            delete formData.roleId; // 清除 roleId
            roleAdd(formData).then(res => {
              if (res.data) {
                this.$message.success(res.msg || "新增成功！");
                this.deptFormVisible = false;
                this.onGetDataList();
              }
            });
          } else {
            updeteRole({
              ...this.form,
              roleId: this.updateId
            }).then(r => {
              if (r.data) {
                this.$message.success(r.msg || "修改成功！");
                this.deptFormVisible = false;
                this.onGetDataList();
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 删
    deleteData(row) {
      this.$confirm(`提示，确定要删除该条数据吗？`, {
        title: "提示",
        showCancelButton: true,
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        type: "warning",
        // 为按钮添加图标并设置为 mini 尺寸
        confirmButtonClass: "el-icon-check el-button--mini", // 确定按钮的图标和尺寸
        cancelButtonClass: "el-icon-close el-button--mini" // 取消按钮的图标和尺寸
      })
        .then(() => {
          deleteRole({ ids: [row.roleId] }).then(res => {
            if (res?.data) {
              this.$message.success(res.msg || "删除成功");
              this.onGetDataList();
              this.form.menuIds = [];
            }
          });
        })
        .catch(error => {
          console.log(error);
          // 取消删除时显示提示
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 改
    updateData(row) {
      this.queryMenuTree();
      this.dialogTitle = "修改";
      this.deptFormVisible = true;
      this.updateId = row.roleId;
      roleById({ id: row.roleId }).then(res => {
        Object.assign(this.form, res?.data);
        // 确保所有数据都加载完毕后再设置选中项
        this.$nextTick(() => {
          // 这里直接一次性设置所有的选中项
          this.$refs.subRoleTree.setCheckedKeys(res.data.menuIds); // 直接设置选中节点
        });
      });
    },
    // 查
    onGetDataList() {
      this.tableLoading = true;
      getRoleList({
        ...this.queryParams,
        ...this.pageParams
      })
        .then(res => {
          const { records, total } = res.data;
          this.tableData = records;
          this.pageParams.total = total;
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },

    handleroleAdd() {
      this.queryMenuTree();
      this.dialogTitle = "新增";
      this.deptFormVisible = true;
    },
    handleDialogClose() {
      this.resetForm("form");
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 查询
    onSearch() {
      this.onGetDataList();
    },
    // 重置
    onReset() {
      this.pageParams.pageNum = 1;
      this.pageParams.pageSize = 10;
      this.queryParams.roleName = "";
      this.onSearch();
    },
    // 分页方法
    onChangePages(pageInfo) {
      this.pageParams.pageNum = pageInfo.page;
      this.pageParams.pageSize = pageInfo.limit;
      this.onGetDataList();
    }
  }
};
</script>
<style lang="less" scoped>
.analyse-container {
  display: flex;
  height: 95vh;
}

.form-item-width {
  width: 250px;
}

.right-btns {
  position: absolute;
  right: 20px !important;
}

.border-bottom {
  border-bottom: 1px solid #e2e2e4;
}

.margin-top {
  margin-top: -15px;
}

.custom-tree-node {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;

  .tree-node-label {
    font-size: 12px;
    font-weight: bold;
  }
}

.el-tree {
  border: 1px solid #dbdbdb;
}
</style>
